import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../../services/auth.service";
import {RootShareService} from "../../../../../services/root.shared.service";
import {PupilExam} from "../../../../../models/forms/referral/pupil.exam";

@Component({
    selector: 'pupil-exam-component',
    templateUrl: './pupil.exam.html'
})
export class PupilExamComponent {
    @Input() pupilExam: PupilExam;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
